import { ReactElement } from "react"

import { Column, Columns, Container } from "ui-kit/components-branded"
import { CreatePortalAfterComponent, Footer } from "components"
import { BrowserWarningBanner, BrowserWarningType } from "components/BrowserWarningBanner"
import { useIsDesktop } from "utils/hooks"
import { AFTER_FOOTER } from "utils/constants"
import { InitCallProvider } from "modules/Call/components/InitCallProvider"

interface Props {
    left: ReactElement
    right: ReactElement
    header: ReactElement
}

export function LobbyPageLayout({ header, left, right }: Props) {
    const isDesktop = useIsDesktop()
    return (
        <CreatePortalAfterComponent idPortalName={AFTER_FOOTER}>
            {header}
            <Container className="lobby-call-page">
                {isDesktop && (
                    <BrowserWarningBanner
                        type={BrowserWarningType.SessionStartedWide}
                        className="lobby-call-page__browser-warning"
                    />
                )}
                <InitCallProvider>
                    <Columns isDesktop className="lobby-call-page__columns">
                        <Column bulma="is-8-desktop" className="lobby-call-page__column">
                            {!isDesktop && (
                                <BrowserWarningBanner
                                    type={BrowserWarningType.SessionStarted}
                                    className="lobby-call-page__browser-warning"
                                />
                            )}
                            {left}
                        </Column>
                        <Column bulma="is-4-desktop" className="__column">
                            {right}
                        </Column>
                    </Columns>
                </InitCallProvider>
            </Container>

            <Footer className="lobby-call-page__footer" />
        </CreatePortalAfterComponent>
    )
}
